import React from 'react';
import './Privacy.css';

const Privacy: React.FC = () => {
  return (
    <div className="container privacy-page">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Last updated: January 16, 2026</p>
      </div>

      <section className="privacy-section">
        <h2>Overview</h2>
        <p>
          We collect personal information to provide membership services, process orders, and
          maintain account security. This includes contact details, delivery information, and wallet
          activity related to your purchases.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Information We Collect</h2>
        <ul>
          <li>Account details such as name, email, and password.</li>
          <li>Order and transaction history related to wallet activity.</li>
          <li>Delivery and pickup details to fulfill orders.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>How We Use Information</h2>
        <ul>
          <li>To process orders, payments, and wallet transactions.</li>
          <li>To provide customer support and account updates.</li>
          <li>To improve services and maintain platform security.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Data Sharing</h2>
        <p>
          We do not sell personal information. We may share limited data with trusted service
          providers who help us deliver the service, such as payment processors and delivery
          partners. These providers are required to protect your information.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Your Choices</h2>
        <ul>
          <li>You can update your profile information in your account settings.</li>
          <li>You can request account deletion by contacting support.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Contact</h2>
        <p>If you have questions about this policy, contact support through your account dashboard.</p>
      </section>
    </div>
  );
};

export default Privacy;
